import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Checkbox,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Grid,
  Header,
  Icon,
  Input,
  Item,
  Menu,
  Modal,
  Table,
  TextArea,
} from "semantic-ui-react";
import LasMaterialApi from "../../api/lasMaterial";
import Logo from "../../components/Logo/Logo";

import { useAppDispatch as useDispatch } from "../../hooks/redux";
import { downloadFile } from "../../utils/downloadFile";

import { setLasMaterial } from "../../redux/actions/lasMaterial";
import { LasMaterialContractBase } from "../../types/lasMaterialContractBase";
import { setEmail as setEmailRedux } from "../../redux/actions/admin";

import style from "./style.module.css";
import { contractTypeSupported } from "../../utils/contractType";
import { useUploadFile } from "../../hooks/useUploadFile";

export default function LasMaterialTablePage() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [iva, setIva] = useState("");
  const [contract, setContract] = useState<LasMaterialContractBase>();
  const [modalVisible, setModalVisible] = useState(false);
  const [keepConditionsModalVisible, setKeepConditionsModalVisible] =
    useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [keepConfirmationModal, setKeepConfirmationModal] = useState(false);

  const [problemModal, setProblemModal] = useState(false);
  const [problem, setProblem] = useState("");

  const { handleUploadFile, responseOk } = useUploadFile(contract?.id as number, contractTypeSupported.LAS_MATERIALS, "las");

  const history = useHistory();
  const updatedContract = async () => {
    setLoading(true);
    setError("");
    try {
      await LasMaterialApi.updateContract(iva);
      setConfirmationModal(true);
    } catch (err) {
      console.log(err);
      setError("Problema na hora de salvar");
    }
    setLoading(false);
  };

  const partialUpdatedContract = async () => {
    setLoading(true);
    setError("");
    try {
      await LasMaterialApi.partialUpdateContract(iva);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  const setKeepConditions = async (keepConditions: boolean) => {
    setLoading(true);
    setError("");
    try {
      await LasMaterialApi.setKeepConditions(keepConditions);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  const sendProblem = async () => {
    setLoading(true);
    setError("");
    try {
      await LasMaterialApi.setProblem(problem);
      setProblemModal(true);
    } catch (err) {
      console.log(err);
      setError("Problema na hora de enviar");
    }
    setLoading(false);
  };
  const getContract = async () => {
    setLoading(true);
    try {
      const contract = await LasMaterialApi.getContract();

      const mat = contract.lasMaterialBases.sort(function (a, b) {
        let x = a.id;
        let y = b.id;
        return x < y ? -1 : x > y ? 1 : 0;
      });
      if (contract.keepConditions === null && contract.round === 0) {
        setKeepConditionsModalVisible(true);
      } else {
        setContract({ ...contract, lasMaterialBases: mat });
        if (contract.lasMaterialContractUpdate) {
          setIva(contract.lasMaterialContractUpdate.iva);
        }
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const verifyForm = () => {
    if (iva === "") {
      return false;
    }

    return true;
  };

  const execDownloadFile = async () => {
		try {
      console.log(contract?.id);
      if (contract?.id) {        
        downloadFile(contract.id.toString(), contractTypeSupported.LAS_MATERIALS);
      }
		} catch (err) {
      console.log(err);
      setError("Problema ao exportar");
		}
	}

  useEffect(() => {
    getContract();
  }, []);

  useEffect(() => {
    if (responseOk) {      
      getContract();
    }
  }, [responseOk]);

  const validAliquota = (s: string) => {
    if (s.length === 0) {
      return true;
    }
    if (s[0] && !(s[0].match(/\D/g) === null)) {
      return false;
    }

    if (s[1] && !(s[1].match(/\D/g) === null || s[1] === ".")) {
      return false;
    }

    if (s[2] && !(s[2].match(/\D/g) === null || s[2] === ".")) {
      return false;
    }

    if (s.split(".")[1] && s.split(".")[1].length > 2) {
      return false;
    }

    if (s[3] && !(s[3].match(/\D/g) === null || s[3] === ".")) {
      return false;
    }

    if (s[4] && !(s[4].match(/\D/g) === null)) {
      return false;
    }
    if (s.length > 5) {
      return false;
    }

    if (parseFloat(s) >= 100) {
      return false;
    }
    if (s.split(".").length > 2) {
      return false;
    }

    return true;
  };

  const changeDiscontinued = async (id: number, discontinued: boolean) => {
    try {
      await LasMaterialApi.setDiscontinued(id, discontinued);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div className={style.container}>
      <Modal
        onClose={() => {
          setProblemModal(false);
          dispatch(setEmailRedux(null));
          history.replace(`/loginLasMaterial/${contract?.id}`);
        }}
        onOpen={() => setProblemModal(true)}
        open={problemModal}
      >
        <Modal.Header>Confirmação</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Seu problema foi enviado com sucesso, logo entraremos em contato
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="OK"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setProblemModal(false);
              dispatch(setEmailRedux(null));
              history.replace(`/loginLasMaterial/${contract?.id}`);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onOpen={() => setKeepConditionsModalVisible(true)}
        open={keepConditionsModalVisible}
      >
        <Modal.Header>Aviso</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Podemos mantener las condiciones del contrato por un año
              adicional?
            </Header>

            <p>
              Obs: Abriendo uma nueva negociacion la compañia podrá iniciar una
              nueva subasta.
            </p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            loading={loading}
            content="Verificar condiciones"
            // labelPosition="right"
            onClick={async () => {
              partialUpdatedContract();
              await setKeepConditions(true);
              await getContract();
              await setKeepConditionsModalVisible(false);
            }}
            negative
          />
          <Button
            loading={loading}
            content="Mantener"
            // labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setKeepConfirmationModal(true);
              setKeepConditionsModalVisible(false);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Modal
        onOpen={() => setKeepConfirmationModal(true)}
        open={keepConfirmationModal}
      >
        <Modal.Header>Aviso</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Confirma que desea mantener las condiciones actuales?
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            loading={loading}
            content="Cancelar"
            // labelPosition="right"
            onClick={async () => {
              setKeepConfirmationModal(false);
              setKeepConditionsModalVisible(true);
            }}
            negative
          />
          <Button
            loading={loading}
            content="Si"
            // labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setKeepConditions(true);
              updatedContract();
              setKeepConfirmationModal(false);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onClose={() => {
          setConfirmationModal(false);
          dispatch(setEmailRedux(null));
          history.replace(`/loginLasMaterial/${contract?.id}`);
        }}
        onOpen={() => setConfirmationModal(true)}
        open={confirmationModal}
      >
        <Modal.Header>Confirmação</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Su contrato fue enviado con éxito, entraremos en contacto
              finalizando la negociación o con una contraoferta
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="OK"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setConfirmationModal(false);
              dispatch(setEmailRedux(null));
              history.replace(`/loginLasMaterial/${contract?.id}`);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Modal
        onClose={() => setModalVisible(false)}
        onOpen={() => setModalVisible(true)}
        open={modalVisible}
      >
        <Modal.Header>Problema</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>Estoy con problemas</Header>
            <p>Describa el problema</p>
          </Modal.Description>
          <TextArea
            cols="100"
            placeholder="Cuentanos mas sobre su problema"
            value={problem}
            onChange={(e, data) => {
              setProblem(data.value!.toString());
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => setModalVisible(false)}>
            Cancelar
          </Button>
          <Button
            content="Enviar y finalizar"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setModalVisible(false);
              sendProblem();
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Logo />
      <Button
        floated="right"
        loading={loading}
        color="red"
        onClick={() => setModalVisible(true)}
      >
        Estoy con problemas
      </Button>
      {/* <Header as="h1">Smart Contract</Header> */}

      <Grid columns={5} stackable>
        <Grid.Column>
          <Item.Group>
            <Item>
              <Item.Content>
                <Item.Header>Contrato</Item.Header>
                <Item.Meta>
                  <label>Numero:</label>
                  <span>{contract?.contractId}</span>
                  <br />
                  <label>Proveedor:</label>
                  <span>{contract?.supplierName}</span>
                  <br />
                  <label>Moneda:</label>
                  <span>{contract?.currency}</span>
                  <br />
                  <label>Codigo Fiscale:</label>
                  <span>{contract?.fiscalCode}</span>
                  <br />
                  <label>Centro:</label>
                  <span>{contract?.company}</span>
                </Item.Meta>
                <Item.Description>{}</Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Grid.Column>

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>IVA % *: </label>
            <br />
            <Input
              value={iva}
              onChange={(e) => {
                if (validAliquota(e.target.value.replace(",", "."))) {
                  setIva(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(iva))) {
                  setIva("");
                } else {
                  setIva(parseFloat(iva).toFixed(2));
                }
                partialUpdatedContract();
              }}
              placeholder="IVA"
            />
          </Grid.Row>
          <br />
        </Grid.Column>

        <Grid.Column>
          <text>Complete todos los campos *</text>
          <br />

          {contract?.keepConditions === false ? (
            <Button
              loading={loading}
              primary
              disabled={!verifyForm()}
              onClick={updatedContract}
            >
              Enviar
            </Button>
          ) : (
            <>
              <Button
                loading={loading}
                color="red"
                onClick={async () => {
                  await setKeepConditions(false);
                  await getContract();
                }}
              >
                Renegociar
              </Button>
              <Button loading={loading} color="green" onClick={updatedContract}>
                Aceitar
              </Button>
              <br />
              <text>
                Obs: Abriendo uma nueva negociacion la compañia podrá iniciar
                una nueva subasta.
              </text>
            </>
          )}
          <br />
          <text className={style.error}>{error}</text>
        </Grid.Column>
      </Grid>
      <Grid.Column style={{display: "flex", justifyContent: "right"}}>          
        <Dropdown text="Negociación masiva" className="selection">
          <DropdownMenu>
            <DropdownItem text="Descargar Modelo" onClick={execDownloadFile}/>
            <DropdownItem text="Importar Excel" onClick={handleUploadFile}/>
          </DropdownMenu>
        </Dropdown>
      </Grid.Column>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Código</Table.HeaderCell>
            <Table.HeaderCell>Precio Actual</Table.HeaderCell>
            <Table.HeaderCell>Precio Bruto Propuesto</Table.HeaderCell>
            <Table.HeaderCell>Reajuste Percentual</Table.HeaderCell>
            <Table.HeaderCell>Descripcion</Table.HeaderCell>
            <Table.HeaderCell>Plazo de Entrega</Table.HeaderCell>
            {contract?.keepConditions === false ? (
              <>
                <Table.HeaderCell>Nuevo Precio (opcional)</Table.HeaderCell>
                <Table.HeaderCell>Material Descontinuado</Table.HeaderCell>
              </>
            ) : null}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {contract?.lasMaterialBases.map((lasMaterial) => {
            return (
              <Table.Row key={lasMaterial.material}>
                <Table.Cell>{lasMaterial.material}</Table.Cell>
                <Table.Cell>
                  {parseFloat(lasMaterial.price).toFixed(2) +
                    " " +
                    contract.currency}
                </Table.Cell>
                <Table.Cell>
                  {lasMaterial.negotiationPrice
                    ? lasMaterial.negotiationPrice + " " + contract.currency
                    : ""}
                </Table.Cell>
                <Table.Cell>{lasMaterial.raisePercentage + "%"}</Table.Cell>
                <Table.Cell>{lasMaterial.longDescription}</Table.Cell>
                <Table.Cell>{lasMaterial.lasMaterialUpdate?.leadTimeDays ?? ""}</Table.Cell>
                {contract?.keepConditions === false ? (
                  <>
                    <Table.Cell>
                      <Button
                        animated="vertical"
                        color={lasMaterial.updated ? "yellow" : "grey"}
                        onClick={() => {
                          dispatch(setLasMaterial(lasMaterial));
                          history.push({
                            pathname: `/lasMaterialContract/lasMaterial`,
                          });
                        }}
                        disabled={lasMaterial.discontinued}
                      >
                        <Button.Content visible>
                          {lasMaterial.updated
                            ? "Precio Propuesto"
                            : "Nuevo Precio"}
                        </Button.Content>
                        <Button.Content hidden>
                          <Icon name="edit" />
                        </Button.Content>
                      </Button>
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox
                        checked={lasMaterial.discontinued}
                        onChange={(e, data) => {
                          let mat = contract.lasMaterialBases.filter(
                            (it) => it.id !== lasMaterial.id
                          );

                          mat.push({
                            ...lasMaterial,
                            discontinued: data.checked!,
                          });
                          mat = mat.sort(function (a, b) {
                            let x = a.id;
                            let y = b.id;
                            return x < y ? -1 : x > y ? 1 : 0;
                          });

                          setContract({ ...contract, lasMaterialBases: mat });
                          changeDiscontinued(lasMaterial.id, data.checked!);
                        }}
                        label="interrumpido"
                      />
                    </Table.Cell>
                  </>
                ) : null}
              </Table.Row>
            );
          })}
        </Table.Body>

        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan="7">
              <Menu floated="right" pagination>
                <Menu.Item
                  icon
                  onClick={() => {
                    //previus
                  }}
                >
                  <Icon name="chevron left" />
                </Menu.Item>
                <Menu.Item>{/* {page} of {totalPages} */}1 of 1</Menu.Item>
                <Menu.Item
                  icon
                  onClick={() => {
                    //onNextClick
                  }}
                >
                  <Icon name="chevron right" />
                </Menu.Item>
              </Menu>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </div>
  );
}
